import { render, staticRenderFns } from "./img-more.vue?vue&type=template&id=0c12dc64&scoped=true&"
import script from "./img-more.vue?vue&type=script&lang=js&"
export * from "./img-more.vue?vue&type=script&lang=js&"
import style0 from "./img-more.vue?vue&type=style&index=0&id=0c12dc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12dc64",
  null
  
)

export default component.exports